// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"459":"f9b3667f","580":"0c761056","596":"31de2c7f","797":"31de2c7f"}[chunkId] + ".chunk.css";
};